import { useEffect, useState } from 'react';
import { api } from '../api/client';

export default function LibraryRetards() {
  const [rows, setRows] = useState([]);
  const [error, setError] = useState('');

  useEffect(() => {
    api.get('/library/overdue').then((data) => setRows(data || [])).catch((e) => setError(e.message));
  }, []);

  const totalFrais = rows.reduce((s, r) => s + (Number(r.days_overdue) * 100), 0);

  return (
    <>
      <div className="kpi-grid">
        <div className="kpi"><span>Retards</span><strong>{rows.length}</strong></div>
        <div className="kpi gold"><span>Frais estimés</span><strong>{totalFrais.toLocaleString('fr-FR')} XOF</strong></div>
      </div>

      <div className="panel">
        <div className="panel-head"><h2>Emprunts en retard</h2></div>
        <div className="panel-body">
          {error && <div className="form-error">{error}</div>}
          {rows.length === 0 ? <div className="empty">Aucun retard. ✓</div> : (
            <div className="table-wrap"><table>
              <thead>
                <tr>
                  <th>Emprunteur</th><th>Ouvrage</th><th>Code</th>
                  <th>Retour prévu</th><th className="num">Jours retard</th>
                  <th className="num">Frais (XOF)</th><th>Contact parent</th>
                </tr>
              </thead>
              <tbody>{rows.map((r) => {
                const frais = Number(r.days_overdue) * 100;
                return (
                  <tr key={r.id} style={{ background: Number(r.days_overdue) > 7 ? 'var(--danger-soft, #fff5f5)' : '' }}>
                    <td>
                      <b>{r.lastName || r.last_name} {r.firstName || r.first_name}</b>
                      <br /><small className="mono">{r.matricule}</small>
                    </td>
                    <td><b>{r.title}</b><br /><small style={{ color: 'var(--muted)' }}>{r.author}</small></td>
                    <td className="mono">{r.code}</td>
                    <td className="mono" style={{ color: 'var(--danger)', fontWeight: 700 }}>
                      {r.due_date ? new Date(r.due_date).toLocaleDateString('fr-FR') : '—'}
                    </td>
                    <td className="num"><span className="badge red">{r.days_overdue}j</span></td>
                    <td className="num">{frais.toLocaleString('fr-FR')}</td>
                    <td>{r.ppcbPhone || '—'}</td>
                  </tr>
                );
              })}</tbody>
            </table></div>
          )}
        </div>
      </div>
    </>
  );
}
